export default __webpack_public_path__ + "static/media/jo.3abd5f5e.svg";